const Footer = () => {
  return (
    <div
      className=" mt-auto"
      style={{
        height: "20px",
        padding: "20px",
        background: "var(--footer-bg)",
        color: "grey",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        boxShadow: "0px -2px 5px rgba(0, 0, 0, 0.1)",
        fontSize: "12px",
      }}
    >
      <span>
        © {new Date().getFullYear()} ReactAdmin. All Rights Reserved. Powered by
        Folcon Engine.
      </span>
    </div>
  );
};

export default Footer;
